module.exports = __webpack_public_path__ + "img/Flag_of_Madagascar.c9dddf98.svg";